import React, { useState } from 'react';
import { Modal, Box, TextField, Button } from '@mui/material';

interface InputModalProps {
    activeOptionKey:any;
  open: boolean;
  handleClose: () => void;
  handleSave: (sectionHeading: string) => void;
}

const UISectionModal: React.FC<InputModalProps> = ({ activeOptionKey,open, handleClose, handleSave }) => {
  const [sectionHeading, setSectionHeading] = useState("");

  const handleSectionHeadingChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSectionHeading(e.target.value);
  };

  const handleSaveClick = () => {
    handleSave(sectionHeading);
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={{ ...modalStyle }}>
        <h2>Add New Section</h2>
        <TextField
          label="Section Heading"
          value={sectionHeading}
          onChange={handleSectionHeadingChange}
          fullWidth
          margin="normal"
        />
        <div style={{display:"flex",justifyContent:"center",width:"100%"}}>
        <Button variant="contained" color="primary" onClick={handleSaveClick} disabled={!sectionHeading.trim()}>
          Save
        </Button>
        </div>
      </Box>
    </Modal>
  );
};

const modalStyle = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

export default UISectionModal;
